// extracted by mini-css-extract-plugin
export default {"container":"Z6XR+","squareImage":"w1Vyi","wideImage":"_7oemn"};